import { AboutService } from "./about.service";
import { TechUsed } from "./about.models";
import { Component, Inject, Input, OnInit, ViewChild } from "@angular/core";
import { GridOptions } from 'ag-grid-community';
import { AgGridHelperService } from '../reusables/services/ag-grid-helper.service';
import { CVLocalizationService } from '../reusables/services/cv-localization.service';
import { AgGridAngular } from "ag-grid-angular";

@Component({
    selector: 'cv-about',
    templateUrl: './about.component.html'
})
export class AboutComponent implements OnInit{
    @ViewChild('aboutGrid') agGrid: AgGridAngular;

    // Ag-grid configuration:
    public gridOptions: GridOptions = null;

    constructor(
        private agGridHelperService: AgGridHelperService,
        private aboutService: AboutService,
        private cvLocalizationService: CVLocalizationService
    ) { }

    public async createGrid() {
        const techsUsed = await this.aboutService.loadTechsUsed();
        await this.cvLocalizationService.GetSection("About");

        this.gridOptions = this.agGridHelperService.createGridOptions({ // GridOptions
            columnDefs: this.createColumnData(),
            onGridReady: () => {
                this.agGrid?.api.setGridOption('rowData', techsUsed);
                this.agGrid?.api.sizeColumnsToFit();
            },
            getRowId: ({ data: rowData }) => rowData.name,
        });
    }

    async ngOnInit() {
        this.createGrid();
    }

    private createColumnData() {
        return [
            {
                colId: "name",
                field: "name",
                maxWidth: 175,
                headerName: this.cvLocalizationService.getCachedText("About", "Name", "Name")
            },
            {
                colId: "link",
                field: "link",
                headerName: this.cvLocalizationService.getCachedText("About", "Link", "Link"),
                cellRenderer: params => "<a href=" + params.value + ">" + params.value + "</a>"
            },
            {
                colId: "license",
                field: "license",
                maxWidth: 250,
                headerName: this.cvLocalizationService.getCachedText("About", "License", "License"),
            },
            {
                colId: "licenseLink",
                field: "licenseLink",
                headerName: this.cvLocalizationService.getCachedText("About", "License_Link", "License Link"),
                cellRenderer: params => "<a href=" + params.value + ">" + params.value + "</a>"
            },
            {
                colId: "version",
                field: "version",
                maxWidth: 175,
                headerName: this.cvLocalizationService.getCachedText("About", "Version", "Version"),
            }
        ];
    }
}
